// src/components/Gallery.js
import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const imageNames = [
  "1_albik3.jpg",
  "2_auhl9f.jpg",
  "3_kjsb5l.jpg",
  "4_pti19g.jpg",
  "5_idwj9u.jpg",
  "6_bu8a2g.jpg",
  "7_ukwmea.jpg",
  "8_wcgrwc.jpg",
  "9_lhxkjv.jpg",
  "10_qopq0n.jpg",
  "11_unhtvl.jpg",
  "12_c7pvgg.jpg",
  "13_rhgcba.jpg",
  "14_hwo7yn.jpg",
  "15_kkiabe.jpg",
  "16_bahyym.jpg",
  "17_iw0f8y.jpg",
  "18_urlhkj.jpg",
  "19_ha0nur.jpg",
  "20_daidy2.jpg",
  "21_b8qspv.jpg",
  "22_tdbk6v.jpg",
  "23_bl1yvo.jpg",
  "24_zb1b25.jpg",
  "25_vbi99a.jpg",
  "26_w44ihe.jpg",
  "27_gfbfpj.jpg",
  "28_bn3m1s.jpg",
  "29_jbty9h.jpg",
  "30_fvajfr.jpg",
  "31_dnclkv.jpg"
];

const baseURL = "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1747665484";

const images = imageNames.map((name) => ({
  src: `${baseURL}/${name}`,
}));

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  return (
    <section className="py-20 bg-white px-20">
      <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
        {images.map((img, i) => (
          <img
            key={i}
            src={img.src}
            onClick={() => {
              setIndex(i);
              setOpen(true);
            }}
            alt={`Gallery ${i}`}
            className="w-full cursor-pointer rounded-lg transition-transform hover:scale-105" loading="lazy"
          />
        ))}
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={images}
        index={index}
        on={{ view: ({ index }) => setIndex(index) }}
      />
    </section>
  );
};

export default Gallery;
